import React, {useEffect} from 'react';
import RemovedAds from '../components/ads/removed-ads.jsx';

export default function Removed() {
    useEffect(() => {
        document.title = 'Removed Ads | FameWheels';
      }, []);
    return (
        <>


            <RemovedAds />
        </>
    );
}